<template>
  <div id="app">
    <!-- 已下线：登录、注册功能 -->
    <hbanner></hbanner>
    <hnav></hnav>
    <section class="content">
      <router-view></router-view>
    </section>
    <footer>
      <template v-if="$HUDONGFENG">
        <div height="80" class="foot-link">
          <span>互动峰科技（北京）有限公司</span>
          <span>电话：010-59798875</span>
        </div>
        <div height="80" class="foot-copyright">
          <img class="beian-img" src="./assets/beian.png" />
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802047108"
            rel="noreferrer"
            target="_blank"
            style="text-decoration:none; margin-right:10px"
          >京公网安备11010802047108号</a>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="nofollow"
            style="text-decoration:none;"
          >京ICP备06057344号-1</a>
          互动峰科技（北京）有限公司版权所有 Copyright 2025
        </div>
      </template>
      <template v-else>
        <div height="80" class="foot-link">
          <span>银川好大夫互联网医院有限公司</span>
          <span>电话：010-59798875</span>
        </div>
        <div height="80" style="color: #999;text-align: center;margin-bottom: 5px">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="nofollow"
            style="text-decoration:none;"
          >宁ICP备16000822号-5</a>
          银川好大夫互联网医院有限公司版权所有 Copyright 2025
        </div>
        <div height="80" style="color: #999;text-align: center;">
          <!-- <router-link class="m-u-l-link" to="/zizhi" style="text-decoration: none">互联网药品信息服务资格证书 (京)-非经营性-2021-0042</router-link> -->
        </div>
      </template>
    </footer>
  </div>
</template>

<script>
import hbanner from "./components/banner";
import hnav from "./components/nav";

export default {
  components: { hbanner, hnav },
  name: "App"
};
</script>

<style>
body,
html {
  padding: 0 !important;
}

* {
  margin: 0;
  padding: 0;
}

ul li {
  list-style-type: none;
}

#app {
  max-width: 890px;
  margin: 0 auto;
  /* background: #f4f4f4; */
  font-size: 20px;
  padding-bottom: 50px;
  box-sizing: border-box;
  position: relative;
}

.content {
  min-height: calc(100vh - 300px);
  padding: 0;
  margin: 0;
  background-color: #ffffff;
}

footer,
footer a {
  color: #999;
  font-size: 12px;
}

.foot-link {
  text-align: center;
  padding-top: 50px;
  margin-bottom: 5px;
}
.foot-copyright {
  color: #999;
  text-align: center;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.foot-link span {
  padding-right: 10px;
}
.beian-img {
  width: 15px;
  height: 15px;
}
</style>
